import { useMemo } from 'react';

import { FlowEdge, FlowNode } from '../Models/GraphModel';
import { getCachedAgentToolActivityIds } from '../Services/AgentToolGraph';

export function useAgentToolActivityIds(edges: FlowEdge[], nodes?: FlowNode[]): Set<string> {
	return useMemo(() => getCachedAgentToolActivityIds(edges, nodes), [edges, nodes]);
}

export function useIsAgentToolActivity(edges: FlowEdge[], activityId: string | undefined, nodes?: FlowNode[]): boolean {
	const activityIds = useAgentToolActivityIds(edges, nodes);
	return activityId !== undefined && activityIds.has(activityId);
}
